/** Settings are panels of one workspace; changing panels must not replace its route tree. */
export function isSettingsPanelSwitch(from: string, to: string): boolean {
  if (!to.startsWith("/") || to.startsWith("//")) return false
  const settings = /^\/(?:crm\/)?settings(?:\/|$)/
  const currentPath = from.split(/[?#]/)[0]
  const targetPath = to.split(/[?#]/)[0]
  return settings.test(currentPath) && settings.test(targetPath)
}
